<template>
  <div class="reception-item-select__wrapper">
    <span class="reception-item-select__title">受付項目</span>
    <select
      class="reception-item-select__select js-reception-item-select"
      @change="onChangeReceptionItem"
    >
      <template v-for="receptionItem in receptionItems">
        <option
          v-if="receptionItem.isDeleted == 0"
          :key="receptionItem.hospitalId"
          :value="receptionItem.hospitalId"
          :selected="receptionItem.hospitalId == selectedReceptionItemId"
        >
          {{ receptionItem | receptionItemNameWithPrefix }}
        </option>
      </template>
    </select>
    <span class="fa fa-chevron-down reception-item-select__chevron-down-icon"></span>
  </div>
</template>

<script>
import { axios } from '@v2/utils/httpRequest.js';
import $ from 'jquery';

export default {
  components: {},
  filters: {
    receptionItemNameWithPrefix(receptionItem) {
      const receptionItemName = receptionItem.receptionItemName;
      return receptionItem.isEnabled == 1 ? receptionItemName : `[非表示] ${receptionItemName}`;
    },
  },
  props: {
    selectedReceptionItemId: {
      type: String,
      default: null,
    },
    isAlertEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      receptionItems: [],
      isEdited: false,
    };
  },
  created() {
    this.fetch();
  },
  mounted: function () {
    let vue = this;
    $('input, select, textarea')
      .not('.js-reception-item-select')
      .change(function () {
        vue.checkIsEdited();
      });
  },
  methods: {
    fetch() {
      axios
        .get('/api/v1/clinic/reception_items')
        .then((response) => {
          this.receptionItems = response.data.receptionItems;
        })
        .catch((_) => {
          this.$swal('通信エラーが発生しました');
        });
    },
    checkIsEdited() {
      this.isEdited = true;
    },
    onChangeReceptionItem(event) {
      const receptionItemId = event.target.value;

      if (!this.isAlertEnabled || !this.isEdited) {
        this.changeReceptionItem(receptionItemId);
        return;
      }

      this.$swal({
        title: '受付項目の変更',
        text: '受付項目を変更してもよろしいですか？\n保存前に入力していた内容は保存されません。',
        icon: 'warning',
        buttons: ['キャンセル', 'OK'],
        dangerMode: true,
      }).then((willChange) => {
        if (willChange) {
          this.changeReceptionItem(receptionItemId);
        } else {
          event.target.value = this.selectedReceptionItemId;
        }
      });
    },
    changeReceptionItem(receptionItemId) {
      if (this.$route === undefined) {
        const url = new URL(window.location.href);
        url.searchParams.delete('reception_item_id');
        url.searchParams.append('reception_item_id', receptionItemId);
        location.href = url;
      } else {
        const newQuery = Object.assign({}, this.$route.query, { reception_item_id: receptionItemId });
        //this.$router.pushで同じコンポーネントに遷移できないのでリロードを実行
        this.$router.push({ query: newQuery });
        location.reload();
      }
    },
  },
};
</script>
